export function requireEnv(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key]
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`)
  }
  return value
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT ?? '10000'),
  appName: import.meta.env.VITE_APP_NAME ?? 'Enterprise',
  appVersion: import.meta.env.VITE_APP_VERSION ?? '0.1.0',
} as const

export type Env = typeof env
